import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { TextBlockForContentCards } from '../TextBlockForContentCards';
import { Link } from '~/shared/components/Link';
import { m } from 'framer-motion';
import { breakpoints } from '~/theme';

export const StyledMarketingSpotImageWrapper = styled.div<{
    isDouble?: boolean;
    stretch?: boolean;
}>(
    ({ theme }) => ({
        position: 'relative',
        width: '100%',
        aspectRatio: `${theme.aspectRatios.productImageSingle}`,
    }),
    ifProp('isDouble', ({ theme }) => ({
        aspectRatio: `${theme.aspectRatios.productImageDouble}`,
    })),

    ifProp('stretch', {
        aspectRatio: 'unset',
        height: '100%',
    })
);

export const StyledMarketingSpot = styled(m(Link))<{ isDouble: boolean }>(
    ({ theme }) => ({
        position: 'relative',
        fontFamily: `${theme.fonts.body}`,
        color: `${theme.colors.dark}`,
        display: 'flex',
        flexDirection: 'column',
    }),
    ifProp('isDouble', () => ({
        gridColumn: 'span 2',
    }))
);

export const StyledSignUpButton = styled.button<{ backgroundColor?: string }>(
    ({ theme, backgroundColor }) => ({
        backgroundColor: backgroundColor,
        flex: '1',
        border: 'none',
        appearance: 'none',
        textAlign: 'left',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: theme.spaces[2],
        padding: `${theme.spaces[3]} ${theme.spaces[4]}`,

        [breakpoints.md]: {
            padding: `${theme.spaces[4]} ${theme.spaces[4]}`,
        },

        svg: {
            height: 24,
            width: 24,
            color: theme.colors.light,
        },
    })
);

export const StyledSignUpButtonTexts = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spaces[1],
}));

export const StyledTextBlockWrapper = styled.div({
    flex: '1',
});

export const StyledTextBlockForContentCards = styled(TextBlockForContentCards)({
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-start',
});

export const StyledArrowWrapper = styled.div<{ hideOnMobile?: boolean }>(({ hideOnMobile }) => ({
    display: hideOnMobile ? 'none' : 'block',

    [breakpoints.md]: {
        display: 'block',
    },
}));
